
export default function CompetitiveEdgeSection() {
  const advantages = [
    {
      icon: 'ri-rocket-2-line',
      title: 'Rapid Launch Capability',
      description: 'Our Yuga-1 launch vehicle delivers payloads to orbit with unprecedented speed and reliability.',
      metric: '72 Hours',
      metricLabel: 'Mission Ready Time'
    },
    {
      icon: 'ri-cpu-line',
      title: 'AI-Powered Systems',
      description: 'Advanced artificial intelligence optimizes mission parameters and autonomous decision-making.',
      metric: '99.8%',
      metricLabel: 'Mission Success Rate'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Cost-Effective Solutions',
      description: 'Revolutionary manufacturing processes reduce launch costs by up to 60% compared to traditional methods.',
      metric: '60%',
      metricLabel: 'Cost Reduction'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Security',
      description: 'End-to-end encryption and cybersecurity protocols protect sensitive mission data.',
      metric: '256-bit',
      metricLabel: 'Encryption Standard'
    }
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our Competitive Edge
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Discover what sets Vyoamyug apart in the global aerospace industry
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {advantages.map((advantage, index) => (
            <div key={index} className="bg-black rounded-2xl p-8 border border-gray-800 hover:border-blue-500 transition-all duration-500 group">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${advantage.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4">{advantage.title}</h3>
              <p className="text-gray-400 leading-relaxed mb-6">{advantage.description}</p>
              
              <div className="border-t border-gray-800 pt-6">
                <div className="text-3xl font-bold text-blue-400 mb-2">{advantage.metric}</div>
                <div className="text-sm text-gray-500 uppercase tracking-wide">{advantage.metricLabel}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-600/10 to-purple-600/10 rounded-2xl p-8 max-w-4xl mx-auto border border-blue-500/20">
            <h3 className="text-3xl font-bold text-white mb-4">Ready to Launch Your Mission?</h3>
            <p className="text-gray-300 mb-8 leading-relaxed">
              Partner with us to transform your aerospace ambitions into reality with our cutting-edge technology and proven expertise.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold py-4 px-8 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer">
                Start Your Project
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}